import { Injectable } from "@angular/core"
import { Actions, Effect } from "@ngrx/effects"
import { Action } from "@ngrx/store"
import { Observable } from "rxjs/Observable"
import {
  CREATE_EVENT,
  ADD_EVENT,
  CREATE_EVENT_FAILURE,
  POPULATE_EVENTS,
  FETCH_EVENTS_FAILURE,
  FETCH_EVENTS,
  FETCH_EVENT,
  FETCH_EVENT_FAILURE,
  POPULATE_ACTIVE_EVENT,
  DELETE_TICKET_FROM_EVENT,
  DELETE_TICKET_FROM_EVENT_FAILURE,
  DELETED_TICKET_FROM_EVENT,
  PURCHASE_TICKETS_AS_GUEST_FAILURE,
  PURCHASED_TICKETS_AS_GUEST,
  PURCHASE_TICKETS_AS_GUEST,
  PURCHASE_TICKETS_AS_EXISTING,
  PURCHASED_TICKETS_AS_EXISTING,
  PURCHASE_TICKETS_AS_EXISTING_FAILURE,
  PURCHASE_TICKET_AS_STAFF,
  PURCHASED_TICKET_AS_STAFF,
  PURCHASE_TICKET_AS_STAFF_FAILURE,
  CREATED_EVENT,
  UPDATED_EVENT,
  UPDATE_EVENT_FAILURE,
  UPDATE_EVENT
} from "../events";
import { Model } from "@models/model";
import { Event } from "@models/event";
import { EventService } from "@services/event";
import { TicketService } from "@services/ticket";
import { TicketAllocation } from "@models/ticket-allocation";
import { Ticket } from "@models/ticket";

export interface EventPurchaseAsExistingParams {
  ticket_allocation_ids: number[],
  student_id: number,
  skip_payment: boolean,
}

interface TicketWithinAllocation {
  allocation: TicketAllocation,
  ticket: Ticket,
}

@Injectable()
export class EventEffects {

  constructor(
    private actions: Actions,
    private eventService: EventService,
    private ticketService: TicketService,
  ) {}

  @Effect() index = this.actions
    .ofType(FETCH_EVENTS)
    .map((action: Action) => action.payload)
    .switchMap((e: Event) => this.eventService.index()
      .map((e: Event) => ({ type: POPULATE_EVENTS, payload: e }))
      .catch(() => Observable.of({ type: FETCH_EVENTS_FAILURE }))
    )
    .share()

  @Effect() fetch = this.actions
    .ofType(FETCH_EVENT)
    .map((action: Action) => action.payload)
    .switchMap((id: number) => this.eventService.fetch(id)
      .map((e: Event) => ({ type: POPULATE_ACTIVE_EVENT, payload: e }))
      .catch(() => Observable.of({ type: FETCH_EVENT_FAILURE }))
    )
    .share()

  @Effect() create = this.actions
    .ofType(CREATE_EVENT)
    .map((action: Action) => action.payload)
    .switchMap((e: Event) => this.eventService.create(e)
      .map((e: Event) => ({ type: CREATED_EVENT, payload: e }))
      .catch(() => Observable.of({ type: CREATE_EVENT_FAILURE }))
    )
    .share()

  @Effect() update = this.actions
    .ofType(UPDATE_EVENT)
    .map((action: Action) => action.payload)
    .switchMap((e: Event) => this.eventService.update(e)
      .map((e: Event) => ({ type: UPDATED_EVENT, payload: e }))
      .catch(() => Observable.of({ type: UPDATE_EVENT_FAILURE }))
    )
    .share()

  @Effect() deleteTicket = this.actions
    .ofType(DELETE_TICKET_FROM_EVENT)
    .map((action: Action) => action.payload)
    .switchMap((t: TicketWithinAllocation) => this.ticketService.delete(t.ticket.id)
      .map((ticketId: number) => ({
        type: DELETED_TICKET_FROM_EVENT,
        payload: t,
      }))
      .catch(() => Observable.of({
        type: DELETE_TICKET_FROM_EVENT_FAILURE,
        payload: t,
      }))
    )
    .share()

  @Effect() purchaseTicketsAsGuest = this.actions
    .ofType(PURCHASE_TICKETS_AS_GUEST)
    .switchMap((a: Action) => this.eventService.purchaseTicketAsGuest(a.payload)
      .map((tickets: Ticket[]) => ({ type: PURCHASED_TICKETS_AS_GUEST, payload: tickets }))
      .catch(err => Observable.of({
        type: PURCHASE_TICKETS_AS_GUEST_FAILURE,
        payload: err.errors ? Model.getJsonApiErrors(err.errors) : Model.serverError,
      }))
    )
    .share()

  @Effect() purchaseTicketsAsExisting = this.actions
    .ofType(PURCHASE_TICKETS_AS_EXISTING)
    .switchMap((a: Action) => this.eventService.purchaseTicketAsExisting(a.payload)
      .map((tickets: Ticket[]) => ({ type: PURCHASED_TICKETS_AS_EXISTING, payload: tickets }))
      .catch(err => Observable.of({
        type: PURCHASE_TICKETS_AS_EXISTING_FAILURE,
        payload: err.errors ? Model.getJsonApiErrors(err.errors) : Model.serverError,
       }))
    )
    .share()

  @Effect() purchaseTicketsAsStaff = this.actions
    .ofType(PURCHASE_TICKET_AS_STAFF)
    .switchMap((a: Action) => this.eventService.purchaseTicketAsStaff(a.payload)
      .map((tickets: Ticket[]) => ({ type: PURCHASED_TICKET_AS_STAFF, payload: tickets }))
      .catch(err => Observable.of({
        type: PURCHASE_TICKET_AS_STAFF_FAILURE,
        payload: err.errors ? Model.getJsonApiErrors(err.errors) : Model.serverError,
      }))
    )
    .share()
}



// WEBPACK FOOTER //
// /Users/jason/src/matrix/client/src/app/reducers/effects/event.ts